import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=4fe20189&scoped=true"
import script from "./Licence.vue?vue&type=script&lang=ts"
export * from "./Licence.vue?vue&type=script&lang=ts"
import style0 from "./Licence.vue?vue&type=style&index=0&id=4fe20189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe20189",
  null
  
)

export default component.exports